import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async get ({ commit, dispatch }) {
    try {
      const { data } = await directus.getItem('data_init', 1)
      commit('setAttr', {
        name: 'model',
        value: data
      })
      dispatch('set')

      return true
    } catch (err) {
      errorDirectus(err, dispatch)
      return false
    }
  }
}
